import React from 'react'
import './experience.css'
import {AiFillCheckCircle} from 'react-icons/ai'

const Experience = () => {
  return (
    <section id='experience'>
      <h5>Skills I have</h5>
      <h2>My Experience</h2>

      <div className='container experience__container'>
        <div className='experience__languages'>
          <h3>Core Cinematography</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Visual Storytelling</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Shot Composition & Framing</h4>
                <small className='text-light'>Professional</small>
              </div>               
            </article>
            {/* <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Node.JS</h4>
                <small className='text-light'>Experienced</small>
              </div>               
            </article> */}
            {/* <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>MongoDB</h4>
                <small className='text-light'>Experienced</small>
              </div>               
            </article> */}
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Lighting Design</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            {/* <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>HTML, CSS</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article> */}
            {/* <article className='experience__details'>
            <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Assembly</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article> */}
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Camera Movements</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>
        </div>


        <div className='experience__technologies'>
        <h3>Creative Director</h3>
          <div className='experience__content'>

            <article className='experience__details'>
                <AiFillCheckCircle className='experience__details-icon'/>
                <div>
                  <h4>Campaign & Content Strategy</h4>
                  <small className='text-light'>Experienced</small>
                </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Media & Brand Communication</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Storyboarding & Mood Boards</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Idea Execution</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            
            
          </div>          
        </div> 
      
        <div className='experience__tools'>
        <h3>Team & Project Management</h3>
          <div className='experience__content'>
          
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Leading Creative Teams</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
              <h4>Client Communication</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
           <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Business Development</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Presentation & Marketing</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            {/* <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Google Colab</h4>
                <small className='text-light'>Trained</small>
              </div>
            </article> */}
            {/* <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>MySQL</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article> */}
          </div>          
        </div> 

        <div className='experience__tools'>
        <h3>Live Stories</h3>
          <div className='experience__content'>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Documentary Filmmaking</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Candid & Portrait Photography</h4>
                <small className='text-light'>Professional</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Business Development</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
            <article className='experience__details'>
              <AiFillCheckCircle className='experience__details-icon'/>
              <div>
                <h4>Presentation & Marketing</h4>
                <small className='text-light'>Experienced</small>
              </div>
            </article>
          </div>          
        </div> 
      </div>
    </section>
  )
}

export default Experience